module.exports = __webpack_public_path__ + "static/attribution@2x-66559344851ebb09d60dfa86a7debb70.png";